<template>
  <div id="services-container">
    <ServiceCard
      v-for="service in servicesArray"
      :key="service.title"
      :title="service.title"
      :slug="service.slug"
      :description="service.description"
      :imgUrl="service.imgUrl"
      :imgAlt="service.imgAlt"
    />
  </div>
</template>

<script>
import ServiceCard from "@/components/ServiceCard";

export default {
  props: ["servicesArray"],

  components: {
    ServiceCard
  },
  data() {
    return {};
  }
};
</script>

<style scoped lang="scss">
#services-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  @include for-tablet-portraid-up {
    // justify-content: start;
    // grid-template-columns: repeat(2, 300px);
    // grid-template-rows: repeat(2, 450px);
  }
}
</style>